var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPfpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 0C20.8214 0 0 20.8183 0 46.5C0 72.1817 20.8194 93 46.5 93C72.1826 93 93 72.1817 93 46.5C93 20.8183 72.1826 0 46.5 0ZM46.5 13.904C54.9969 13.904 61.8822 20.7917 61.8822 29.2849C61.8822 37.7801 54.9969 44.6657 46.5 44.6657C38.0072 44.6657 31.1219 37.7801 31.1219 29.2849C31.1219 20.7917 38.0072 13.904 46.5 13.904ZM46.4898 80.8424C38.0154 80.8424 30.2538 77.756 24.2672 72.6474C22.8088 71.4035 21.9673 69.5794 21.9673 67.6655C21.9673 59.0518 28.9384 52.158 37.5538 52.158H55.4503C64.0677 52.158 71.0123 59.0518 71.0123 67.6655C71.0123 69.5815 70.1748 71.4015 68.7144 72.6454C62.7299 77.756 54.9662 80.8424 46.4898 80.8424Z",
    fill: "#C6C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfpIcon);
export default __webpack_public_path__ + "static/media/pfpIcon.d472bf2aedc9728c17ad20c7bb52d103.svg";
export { ForwardRef as ReactComponent };